import { getRuntimeInfo } from '@/hooks/useRuntimeInfo';
import { CfChallengeTexts, configureCfChallenge } from '@zenlayer/portal-utils';
import t from '@zenlayer/zen-intl18';

/**
 * 初始化 Cloudflare 质询/拦截处理。
 *
 * - 质询(challenge)：弹出原生遮罩引导用户完成人机验证，验证通过后由 fetch 层透明重发，
 *   业务侧无感知。
 * - 拦截(block)：跳转到 /error。
 *
 * locale 变更时 src/index.ts 会 reload 页面并重新执行本函数，因此文案在此处一次性求值即可。
 */
export const setupCfChallenge = () => {
  const siteKey = getRuntimeInfo().turnstile_sitekey;

  // 文案延迟到质询/拦截真正触发时再求值：i18n 资源是异步接口拉取的，本函数在
  // index.ts 启动期执行，此刻 t() 可能尚未就绪（会回退成 key/英文）。
  const resolveTexts = (): CfChallengeTexts => ({
    blockTitle: t('h1i47rlf87rj'),
    blockDesc: t('Scj3f2VoIg8E', { host: globalThis.location.host }),
  });

  configureCfChallenge({
    // 仅在配置了 sitekey 时启用：challenge 走内联 Turnstile 渲染，必需 sitekey。
    // 内联 pre-clearance 依赖真实 CF 边缘下发 cf_clearance，无法用本地 mock 完整自测，
    // 只能在 pre/prod 验证（本地仅能触发遮罩、看到 widget，重发仍会被质询）。
    enabled: !!siteKey,
    siteKey,
    texts: resolveTexts,
    blockRedirectUrl: () => {
      return `/error?code=403&isCfBlocked=true`;
    },
  });

  if (!__PRODUCTION__) {
    import('./cfChallengeDevTest').then((m) => m.mountCfChallengeTester());
  }
};
